import { useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import { isPossiblePhoneNumber } from "react-phone-number-input";
import printJS from "print-js";

import classes from "./profile.module.scss";
import ProfileHead from "./ProfileHead";
import ProfileTab from "./ProfileTab";

import api from "@/services/api.service";
import { toast } from "@/services/Utils";
import { base64toBlob } from "@/hooks/printer/useBase64";
import useProcessingStore from "@/stores/useProcessingStore";

import Head from "@/components/Content/Head";
import Fetching from "@/components/Fetching/Fetching";

import { base_profile } from "./profile.constants";

const Profile = () => {
	const { addToast } = useToasts();
	const startProcessing = useProcessingStore((state) => state.startProcessing);
	const stopProcessing = useProcessingStore((state) => state.stopProcessing);

	const [data, setData] = useState({ ...base_profile });
	const [isFetching, setIsFetching] = useState(true);

	useEffect(() => {
		api.get("/client/profile", {}).then((response) => {
			setData({ ...response.profile });
			setIsFetching(false);
		});
	}, []);

	const validSave = () => {
		if (!data.name) {
			toast(addToast, "Debe ingresar un nombre para guardar.", "error");
			return false;
		}

		if (!data.email) {
			toast(addToast, "Debe ingresar un email para guardar.", "error");
			return false;
		}

		if (data.phone && isPossiblePhoneNumber(data.phone) === false) {
			toast(addToast, "Debe ingresar un teléfono válido para guardar.", "error");
			return false;
		}

		if (data.password) {
			if (data.password !== data.confirm_password) {
				toast(addToast, "Las contraseñas ingresadas no coinciden.", "error");

				return false;
			}

			if (data.password.length < 4) {
				toast(addToast, "La contraseña debe contener al menos 4 caracteres.", "error");

				return false;
			}
		}

		return true;
	};

	const handleSave = () => {
		if (validSave()) {
			setIsFetching(true);
			api.post("/client/profile/save", data).then((response) => {
				const { profile } = response;
				if (profile) {
					setData(profile);
					toast(addToast, "Perfil actualizado correctamente.", "success");
				}
				setIsFetching(false);
			});
		}
	};

	const printQR = async () => {
		startProcessing("Generando Código QR...");

		try {
			const response = await api.post("/admin/users/pdf", {
				user_id: data.id,
			});

			if (response?.url) {
				const blobUrl = URL.createObjectURL(base64toBlob(`data:application/pdf;base64,${response.url}`));

				printJS(blobUrl);
			} else {
				toast.error("No se pudo generar el PDF.");
			}
		} catch {
			toast.error("Hubo un error al generar el PDF.");
		} finally {
			stopProcessing();
		}
	};

	if (isFetching) {
		return <Fetching />;
	}
	return (
		<>
			{" "}
			<Head title="Perfil" />
			<Row className={`no_print ${classes.main_row}`}>
				<Col md={12} className={classes.main_col}>
					<Row className={classes.main_form}>
						<ProfileHead data={data} setData={setData} />
					</Row>
					<Row className={classes.tab_form}>
						<ProfileTab data={data} setData={setData} />
					</Row>
					<Row className={classes.footer_form}>
						<Button
							variant="secondary"
							onClick={() => printQR()}
							style={{
								marginRight: "10px",
							}}
						>
							IMPRIMIR QR
						</Button>
						<Button variant="success" onClick={() => handleSave()}>
							GUARDAR
						</Button>
					</Row>
				</Col>

				<span
					style={{
						marginTop: "8px",
						fontSize: "11px",
						fontStyle: "italic",
					}}
				>
					{`Versión Agroinventario ${process.env.REACT_APP_VERSION}`}
				</span>
			</Row>
		</>
	);
};

export default Profile;
